/**
 * Health of a project's active sprint: "On Track", "At Risk", "Overdue", or
 * "_" when no sprint is running.
 *
 * Overdue: the end date has passed with work still open. At risk: the share
 * of work left is more than 30 points above the share of time left — behind
 * schedule. Being ahead of schedule is on track, not a risk.
 */
export const projectHealthOf = (sprintInfo, now = new Date()) => {
  if (!sprintInfo?._id) return "_";
  const DAY = 1000 * 60 * 60 * 24;
  const endDate = new Date(sprintInfo.endDate);
  const startDate = new Date(sprintInfo.startDate);
  const totalIssues = sprintInfo.totalIssues || 0;
  const issuesLeft = Math.max(0, totalIssues - (sprintInfo.IssuesDone || 0));

  if (!totalIssues || !issuesLeft) return "On Track";
  if (Number.isFinite(endDate.getTime()) && now > endDate) return "Overdue";

  const totalDays = (endDate - startDate) / DAY;
  const daysLeft = (endDate - now) / DAY;
  const daysLeftPercentage = daysLeft >= 0 && totalDays > 0 ? (daysLeft * 100) / totalDays : 0;
  const issuesLeftPercentage = (issuesLeft * 100) / totalIssues;

  return issuesLeftPercentage - daysLeftPercentage > 30 ? "At Risk" : "On Track";
};
